import { createSlice } from "@reduxjs/toolkit"
import {
  addModifier,
  deleteModifier,
  enableDisableModifier,
  getAllModifier,
  getModifierDetail,
  getModifierDetails,
  getModifierList,
  updateModifier,
  updateModifierStatus,
} from "store/actions/modiferAction"
import { getModifierGroupDetails } from "store/actions/modifierGroupAction"

const initialState = {
  loading: true,
  error: null,
  isLoading: false,
  isUpdating: false,
  itemsPerPage: 12,
  totalCount: null,
  totalPages: null,
  currentPage: 1,
  modifiers: [],
  modifierLists: [],
  modifierDetails: {},
}

const usersSlice = createSlice({
  name: "modifier", //
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET MODIFIER
    builder
      .addCase(getModifierDetails.pending, state => {
        state.loading = true
      })
      .addCase(getModifierDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.modifiers = data?.modifiers
        }
      })
      .addCase(getModifierDetails.rejected, (state, action) => {
        state.loading = false
      })

    // GET MODIFIER LIST
    builder
      .addCase(getModifierList.pending, state => {
        state.loading = true
      })
      .addCase(getModifierList.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.modifierLists = data
        }
      })
      .addCase(getModifierList.rejected, (state, action) => {
        state.loading = false
      })

    // GET ALL MODIFIER
    builder
      .addCase(getAllModifier.pending, state => {
        state.loading = true
      })
      .addCase(getAllModifier.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.modifiers = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllModifier.rejected, (state, action) => {
        state.loading = false
      })

    // GET MODIFIER DETAILS
    builder
      .addCase(getModifierDetail.pending, state => {
        state.loading = true
      })
      .addCase(getModifierDetail.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.modifierDetails = data
        }
      })
      .addCase(getModifierDetail.rejected, (state, action) => {
        state.loading = false
      })

    // MODIFIER GROUP STATUS UPDATE
    builder
      .addCase(updateModifierStatus.pending, state => {
        state.error = null
        state.isUpdating = true
      })
      .addCase(updateModifierStatus.fulfilled, (state, action) => {
        state.isUpdating = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.modifiers = state.modifiers.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateModifierStatus.rejected, (state, action) => {
        state.isUpdating = false
      })
    // DELETE MODIFIER GROUP
    builder
      .addCase(deleteModifier.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteModifier.fulfilled, (state, action) => {
        const { status } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.modifiers = state.modifiers.filter(item => item._id !== id)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteModifier.rejected, (state, action) => {
        state.isLoading = false
      })

    // ADD MODIFIER GROUP
    builder
      .addCase(addModifier.pending, state => {
        state.error = null
        state.isLoading = true
      })
      .addCase(addModifier.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addModifier.rejected, (state, action) => {
        state.isLoading = false
      })

    // UPDATE MODIFIER
    builder
      .addCase(updateModifier.pending, state => {
        state.error = null
        state.isLoading = true
      })
      .addCase(updateModifier.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateModifier.rejected, (state, action) => {
        state.isLoading = false
      })

    // ENABLE/DISABLE MODIFIER
    builder
      .addCase(enableDisableModifier.pending, state => {
        state.isLoading = true
      })
      .addCase(enableDisableModifier.fulfilled, (state, action) => {
        state.isLoading = false;
    
        const { status } = action.payload; // API response
        const { id, branchId, status: updatedStatus } = action.meta.arg; // Payload data
    
        if (status) {
          // Update the specific modifier's outOfStockForBranches
          state.modifiers = state.modifiers.map(modifier => {
            if (modifier._id === id) {
              return {
                ...modifier,
                outOfStockForBranches: updatedStatus
                  ? // Add branchId if status is true
                    [...new Set([...(modifier.outOfStockForBranches || []), branchId])]
                  : // Remove branchId if status is false
                    (modifier.outOfStockForBranches || []).filter(bId => bId !== branchId),
              };
            }
            return modifier;
          });
        }
      })
      .addCase(enableDisableModifier.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
